import $ from 'jquery';
import React from 'react';
import OptionPopupView from "views/common/OptionPopupView";
import { createRoot } from "react-dom/client";
import HourPackContent from '../../components/settings/HourPackContent';

const HourPackPopupView = OptionPopupView.extend({

    "pageName": "Hour Pack Popup",

    initialize: function(options) {
        this._workspaceUsage = options.workspaceUsage || {};
        this._onPurchase = options.onPurchase;
        this._i18nModule = options.i18nModule;
        this._reactRoot = null;

        // Create content container for React component
        this.contentContainer$el = $('<div class="hour-pack-popup-content"></div>');
        this.contentContainer$el.css("width", "calc(100% - 40px)");
        this.contentContainer$el.css("max-width", "720px");

        const contentView = {};
        contentView.$el = this.contentContainer$el;

        const viewOptions = {
            contentView: contentView,
            contentPosition: "text-not-white",
            addContentAfterEnhancement: true,
            displayTitle: false,
            id: "HourPackPopup"
        };

        OptionPopupView.prototype.initialize.call(this, viewOptions);
    },

    onPopupClosed: function() {
        if (this._reactRoot) {
            this._reactRoot.unmount();
            this._reactRoot = null;
        }
    },

    onPurchaseTriggered: async function(packSize) {
        if (this._onPurchase) {
            try {
                await this._onPurchase(packSize);
            } catch (error) {
                // Controller's handlePurchase already surfaces errors via
                // alertErrorMessage; this catch is defense-in-depth so a
                // rejected promise here never becomes an unhandled rejection.
                console.error("Hour pack purchase callback failed:", error);
            }
        }
    },

    onCancelTriggered: function() {
        this.close();
    },

    _renderReactComponent: function() {
        if (this._reactRoot) {
            this._reactRoot.unmount();
        }

        const root = createRoot(this.contentContainer$el.get(0));

        root.render(
            React.createElement(HourPackContent, {
                workspaceUsage: this._workspaceUsage,
                onPurchase: this.onPurchaseTriggered.bind(this),
                onCancel: this.onCancelTriggered.bind(this),
                i18nModule: this._i18nModule,
                useEditorTheme: true
            })
        );

        this._reactRoot = root;
    },

    addReactWidget: function() {
        this._renderReactComponent();
    },

    onAfterPageShow: function() {
        this.addReactWidget();
    },

    afterRender: function() {
        OptionPopupView.prototype.afterRender.call(this);
    }
});

export default HourPackPopupView;
